import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

const ProtectedRoute: React.FC = () => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  // Show a loading state while checking authentication
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="animate-spin h-10 w-10 rounded-full border-t-2 border-primary-500 border-r-2 border-primary-500 border-b-2 border-transparent"></div>
      </div>
    );
  }

  // If not authenticated after checking, redirect to login page
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Role-based route protection
  if (user?.role === 'SALES_EXECUTIVE' && !location.pathname.startsWith('/sales')) {
    return <Navigate to="/sales/dashboard" replace />;
  }
  if (user?.role === 'ACCOUNTANT' && !location.pathname.startsWith('/accountant')) {
    return <Navigate to="/accountant/dashboard" replace />;
  }
  if (user?.role === 'WRITER' && !location.pathname.startsWith('/writer')) {
    return <Navigate to="/writer/dashboard" replace />;
  }
  if (user?.role === 'MARKETING' && !location.pathname.startsWith('/marketing')) {
    return <Navigate to="/marketing/dashboard" replace />;
  }
  const isAccountantOrderLedgerPeek =
    location.pathname.startsWith('/accountant/ledger/order/');

  if (user?.role === 'MASTER_ADMIN' && (location.pathname.startsWith('/sales') || location.pathname.startsWith('/accountant'))) {
    if (isAccountantOrderLedgerPeek || location.pathname.startsWith('/sales/vendor-onboarding/add')) {
      return <Outlet />;
    }
    return <Navigate to="/" replace />;
  }
  if (user?.role !== 'WRITER' && location.pathname.startsWith('/writer')) {
    if (user?.role === 'SALES_EXECUTIVE') return <Navigate to="/sales/dashboard" replace />;
    if (user?.role === 'ACCOUNTANT') return <Navigate to="/accountant/dashboard" replace />;
    if (user?.role === 'MARKETING') return <Navigate to="/marketing/dashboard" replace />;
    return <Navigate to="/" replace />;
  }
  if (
    user?.role !== 'MARKETING' &&
    user?.role !== 'MASTER_ADMIN' &&
    location.pathname.startsWith('/marketing')
  ) {
    if (user?.role === 'SALES_EXECUTIVE') return <Navigate to="/sales/dashboard" replace />;
    if (user?.role === 'ACCOUNTANT') return <Navigate to="/accountant/dashboard" replace />;
    if (user?.role === 'WRITER') return <Navigate to="/writer/dashboard" replace />;
    return <Navigate to="/" replace />;
  }
  if (user?.role === 'SALES_EXECUTIVE' && location.pathname.startsWith('/accountant')) {
    return <Navigate to="/sales/dashboard" replace />;
  }
  if (user?.role === 'ACCOUNTANT' && (location.pathname.startsWith('/sales') || (!location.pathname.startsWith('/accountant') && location.pathname !== '/login'))) {
    return <Navigate to="/accountant/dashboard" replace />;
  }

  // Otherwise, render the protected content
  return <Outlet />;
};

export default ProtectedRoute; 